/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Buildhover_Version1Inputs */

const id_home_buildhover_version1 = /** @type {(inputs: Home_Buildhover_Version1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versi`)
};

const ms_home_buildhover_version1 = /** @type {(inputs: Home_Buildhover_Version1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versi`)
};

const da_home_buildhover_version1 = /** @type {(inputs: Home_Buildhover_Version1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Version`)
};

const de_home_buildhover_version1 = /** @type {(inputs: Home_Buildhover_Version1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Version`)
};

const en_us2_home_buildhover_version1 = /** @type {(inputs: Home_Buildhover_Version1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Version`)
};

const es_es2_home_buildhover_version1 = /** @type {(inputs: Home_Buildhover_Version1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versión`)
};

const es_mx2_home_buildhover_version1 = /** @type {(inputs: Home_Buildhover_Version1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versión`)
};

const fil_home_buildhover_version1 = /** @type {(inputs: Home_Buildhover_Version1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bersyon`)
};

const fr_home_buildhover_version1 = /** @type {(inputs: Home_Buildhover_Version1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Version`)
};

const it_home_buildhover_version1 = /** @type {(inputs: Home_Buildhover_Version1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versione`)
};

const hu_home_buildhover_version1 = /** @type {(inputs: Home_Buildhover_Version1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verzió`)
};

const nl_home_buildhover_version1 = /** @type {(inputs: Home_Buildhover_Version1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versie`)
};

const no_home_buildhover_version1 = /** @type {(inputs: Home_Buildhover_Version1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versjon`)
};

const pl_home_buildhover_version1 = /** @type {(inputs: Home_Buildhover_Version1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wersja`)
};

const pt_br2_home_buildhover_version1 = /** @type {(inputs: Home_Buildhover_Version1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versão`)
};

const pt_home_buildhover_version1 = /** @type {(inputs: Home_Buildhover_Version1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versão`)
};

const ro_home_buildhover_version1 = /** @type {(inputs: Home_Buildhover_Version1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versiune`)
};

const fi_home_buildhover_version1 = /** @type {(inputs: Home_Buildhover_Version1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versio`)
};

const sv_home_buildhover_version1 = /** @type {(inputs: Home_Buildhover_Version1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Version`)
};

const vi_home_buildhover_version1 = /** @type {(inputs: Home_Buildhover_Version1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phiên bản`)
};

const tr_home_buildhover_version1 = /** @type {(inputs: Home_Buildhover_Version1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sürüm`)
};

const cs_home_buildhover_version1 = /** @type {(inputs: Home_Buildhover_Version1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verze`)
};

const bg_home_buildhover_version1 = /** @type {(inputs: Home_Buildhover_Version1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Версия`)
};

const ru_home_buildhover_version1 = /** @type {(inputs: Home_Buildhover_Version1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Версия`)
};

const uk_home_buildhover_version1 = /** @type {(inputs: Home_Buildhover_Version1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Версія`)
};

const ar_home_buildhover_version1 = /** @type {(inputs: Home_Buildhover_Version1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإصدار`)
};

const hi_home_buildhover_version1 = /** @type {(inputs: Home_Buildhover_Version1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संस्करण`)
};

const th_home_buildhover_version1 = /** @type {(inputs: Home_Buildhover_Version1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เวอร์ชัน`)
};

const ja_home_buildhover_version1 = /** @type {(inputs: Home_Buildhover_Version1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バージョン`)
};

const zh_cn2_home_buildhover_version1 = /** @type {(inputs: Home_Buildhover_Version1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`版本`)
};

const zh_hant1_home_buildhover_version1 = /** @type {(inputs: Home_Buildhover_Version1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`版本`)
};

const ko_home_buildhover_version1 = /** @type {(inputs: Home_Buildhover_Version1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`버전`)
};

/**
* | output |
* | --- |
* | "Version" |
*
* @param {Home_Buildhover_Version1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_buildhover_version1 = /** @type {((inputs?: Home_Buildhover_Version1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Buildhover_Version1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_buildhover_version1(inputs)
	if (locale === "ms") return ms_home_buildhover_version1(inputs)
	if (locale === "da") return da_home_buildhover_version1(inputs)
	if (locale === "de") return de_home_buildhover_version1(inputs)
	if (locale === "en-US") return en_us2_home_buildhover_version1(inputs)
	if (locale === "es-ES") return es_es2_home_buildhover_version1(inputs)
	if (locale === "es-MX") return es_mx2_home_buildhover_version1(inputs)
	if (locale === "fil") return fil_home_buildhover_version1(inputs)
	if (locale === "fr") return fr_home_buildhover_version1(inputs)
	if (locale === "it") return it_home_buildhover_version1(inputs)
	if (locale === "hu") return hu_home_buildhover_version1(inputs)
	if (locale === "nl") return nl_home_buildhover_version1(inputs)
	if (locale === "no") return no_home_buildhover_version1(inputs)
	if (locale === "pl") return pl_home_buildhover_version1(inputs)
	if (locale === "pt-BR") return pt_br2_home_buildhover_version1(inputs)
	if (locale === "pt") return pt_home_buildhover_version1(inputs)
	if (locale === "ro") return ro_home_buildhover_version1(inputs)
	if (locale === "fi") return fi_home_buildhover_version1(inputs)
	if (locale === "sv") return sv_home_buildhover_version1(inputs)
	if (locale === "vi") return vi_home_buildhover_version1(inputs)
	if (locale === "tr") return tr_home_buildhover_version1(inputs)
	if (locale === "cs") return cs_home_buildhover_version1(inputs)
	if (locale === "bg") return bg_home_buildhover_version1(inputs)
	if (locale === "ru") return ru_home_buildhover_version1(inputs)
	if (locale === "uk") return uk_home_buildhover_version1(inputs)
	if (locale === "ar") return ar_home_buildhover_version1(inputs)
	if (locale === "hi") return hi_home_buildhover_version1(inputs)
	if (locale === "th") return th_home_buildhover_version1(inputs)
	if (locale === "ja") return ja_home_buildhover_version1(inputs)
	if (locale === "zh-CN") return zh_cn2_home_buildhover_version1(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_buildhover_version1(inputs)
	return ko_home_buildhover_version1(inputs)
});
export { home_buildhover_version1 as "home.buildHover.version" }